import { Controller } from "@hotwired/stimulus";
import log from "loglevel";

export default class extends Controller {
  static targets = [
    "form",
    "formContainer",
    "submitted",
    "inFlight",
    "resultContainer",
    "result",
  ];
  static values = {
    success: String,
    submitUrl: String,
    recaptchaSiteKey: String,
  };

  connect() {
    log.info("Controller: Call To Action loaded");

    this.showForm();
  }

  postForm(event) {
    log.info("CTA Form Submitted");

    event.preventDefault();

    // Get the form data
    let formData = new FormData(this.formTarget);

    // Add a delay so there's time to see our nice progress indicator
    const promises = [
      this.#submitTo(this.submitUrlValue, formData),
      this.#delay(3000),
    ];

    this.#showInFlight();

    Promise.all(promises)
      .then(() => this.#showResult())
      .catch((error) => this.#showError(`Error: ${error}`));
  }

  showForm() {
    this.#hideAllContainers();
    this.formContainerTargets.forEach((t) => t.classList.remove("d-none"));
  }

  // #private methods

  #showInFlight() {
    this.#hideAllContainers();
    this.inFlightTargets.forEach((t) => t.classList.remove("d-none"));
    this.#scrollResultIntoView();
  }

  #showResult() {
    this.#hideAllContainers();
    this.submittedTargets.forEach((t) => t.classList.remove("d-none"));
    this.#scrollResultIntoView();
  }

  #showError(message) {
    this.resultTarget.innerHTML = message;
    this.#showResult();
    log.error(message);
  }

  #scrollResultIntoView() {
    if (this.resultContainerTarget) {
      const elementTop = this.resultContainerTarget.getBoundingClientRect().y;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const top = scrollTop + elementTop - 100;

      log.info(elementTop);
      log.info(scrollTop);
      log.info(top);

      window.scrollTo({ top: top });

      // this.resultContainerTarget.scrollIntoView({ behavior: 'smooth', block: 'start', blockOffset: 50 });
      // log.info(this.resultContainerTarget.getBoundingClientRect())
      // window.scrollTo({top: -this.resultContainerTarget.getBoundingClientRect().y - 100 })
      // log.info(this.resultContainerTarget.getBoundingClientRect())
    }
  }

  #delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  #hideAllContainers() {
    this.formContainerTargets.forEach((t) => t.classList.add("d-none"));
    this.inFlightTargets.forEach((t) => t.classList.add("d-none"));
    this.submittedTargets.forEach((t) => t.classList.add("d-none"));
  }

  async #submitTo(url, formData) {
    // Check our honeypot
    this.#checkForSpam(formData);

    // Convert the data to a v1.0 contract payload.
    const recaptchaToken = await this.#recpatchaResponse();
    let body = this.#bodyFrom(formData, recaptchaToken);

    log.info("Submitting form data");

    // Post to our service
    let response = await this.#postJson(url, body);

    // Show the result in the logs
    log.info(await response.text());
  }

  async #recpatchaResponse() {
    if (typeof grecaptcha === "undefined") {
      throw new Error(
        "grecaptcha is not defined.  Make sure you have loaded the reCAPTCHA library.",
      );
    }

    if (!grecaptcha.enterprise) {
      throw new Error(
        "grecaptcha.enterprise is not defined. Make sure you loaded enterprise.js and used an Enterprise site key.",
      );
    }

    return new Promise((res, rej) => {
      grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise
          .execute(this.recaptchaSiteKeyValue, { action: "submit" })
          .then((token) => {
            return res(token);
          })
          .catch((error) => {
            return rej(error);
          });
      });
    });
  }

  // Make sure 'email_confirm' field is empty (honeypot technique)
  #checkForSpam(formData) {
    if (formData.get("email_confirm")) {
      log.error("Spam detected");
      throw new Error("Spam detected");
    }
  }

  // Convert the form data to an object that we can send as JSON
  #bodyFrom(formData, recaptchaToken) {
    let data = {};

    formData.forEach((value, key) => (data[key] = value));

    const honeypot =
      typeof data.email_confirm === "string" ? data.email_confirm : "";
    delete data.email_confirm;

    const sourceForm =
      typeof data.inquiry_type === "string"
        ? data.inquiry_type
        : "newsletter_signup";
    const submissionType =
      typeof data.inquiry_type === "string"
        ? "contact_us"
        : "newsletter_signup";

    return JSON.stringify({
      contract_version: "1.0",
      source: {
        site: window.location.hostname,
        form: sourceForm,
        page: window.location.href,
      },
      submission: {
        type: submissionType,
        fields: data,
      },
      security: {
        recaptcha_token: recaptchaToken,
        honeypot,
      },
    });
  }

  async #postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
    });
  }
}
